import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";

@Injectable()
export class AuthProvider {
  constructor(private angularFireAuth: AngularFireAuth) {}

  forgotPassword(email: any) {
    return this.angularFireAuth.auth.sendPasswordResetEmail(email);
  }

  logOut() {
    return this.angularFireAuth.auth.signOut();
  }

  getAuth() {
    return this.angularFireAuth.authState.map(auth => auth);
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts